import styled from "styled-components";

export const MainMapWrapper = styled.div`
  position: relative;
  height: 100vh;
`;

export const MapNoDataWrap = styled.div`
  position: relative;
  display: ${({ show }) => {
    return show ? 'flex' : 'none';
  }};
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(239, 239, 239,0.5);
  ::-webkit-tap-highlight-color: transparent;
  color: #fff;
  height: 100%;
  float: right;
  width: ${({ wd }) => {
    return wd;
  }};
`;

export const MapNoDataMsg = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(150, 150, 150, 0.9);
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
`;